import Icon from '@material-ui/icons/SupervisorAccount';

// platform always makes the following for the signed in user, so there is none to make for another user here
export default {
  Icon,
  dialogs: {
  },
  routes: {
  },
  components: {
  },
  resources: {
  },
};
